<template>
  <!--
    Kiosk stand for square screens of any size. The stand page adapts to the
    viewport width (media queries, the games slider), so scaling it in place
    would still switch to the tablet layout on an 800x800 screen. Instead it
    runs inside a 1400x1400 iframe, where it lays out exactly as on a
    1400x1400 screen, and the frame is scaled to fit this window.

    The scaling is CSS zoom, not transform: scale(). Chrome's device mode
    (DPR override + "Fit to window") drew a transformed iframe at the wrong
    size, while zoom keeps the frame's own viewport at 1400x1400 and only
    shrinks the box it takes on the page.
  -->
  <main class="tournament-demo-stand-1400-page">
    <iframe
        class="tournament-demo-stand-1400-page__frame"
        :src="standURL"
        :style="frameStyle"
        title="Tournament stand"
        @load="hideFrameScrollbar"
    ></iframe>
  </main>
</template>

<script>
const DESIGN_SIZE = 1400;

export default {
    name: "TournamentDemoStand1400",

    data() {
        return {
            viewportWidth: window.innerWidth,
            viewportHeight: window.innerHeight,
        }
    },

    mounted() {
        window.addEventListener('resize', this.onResize);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
    },

    computed: {
        standURL() {
            return this.$router.resolve({
                name: 'tournament-demo-stand',
                params: this.$route.params,
                query: this.$route.query,
            }).href;
        },

        // fit the whole square into the window; the page centres it, so on a
        // non-square window the spare space is split on the longer side
        frameStyle() {
            const scale = Math.min(this.viewportWidth, this.viewportHeight) / DESIGN_SIZE;
            return {
                width: `${DESIGN_SIZE}px`,
                height: `${DESIGN_SIZE}px`,
                zoom: scale,
            };
        },
    },

    methods: {
        onResize() {
            this.viewportWidth = window.innerWidth;
            this.viewportHeight = window.innerHeight;
        },

        // the stand is taller than the square, so the frame scrolls; hide its
        // scrollbar (it would also take ~15px off the 1400px layout on desktop)
        // while keeping wheel/touch scrolling. The frame is same-origin, so
        // this is done from here and the stand page itself stays untouched.
        hideFrameScrollbar(event) {
            const doc = event.target.contentDocument;
            if (!doc) {
                return;
            }
            const style = doc.createElement('style');
            style.textContent = 'html { scrollbar-width: none; } '
                + 'html::-webkit-scrollbar { display: none; }';
            doc.head.appendChild(style);
        },
    },
}
</script>

<style scoped>
.tournament-demo-stand-1400-page {
    position: fixed;
    inset: 0;
    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #100823;
}

.tournament-demo-stand-1400-page__frame {
    display: block;
    flex: none;
    border: 0;
}
</style>
